import moment from 'moment';

export const mapToInitialValues = (impresa) => {
  return {
    id: impresa.id || null,
    tipoGestione: impresa.tipoGestione || null,
    tipoProdotto: impresa.tipoProdotto || null,
    importoRichiesto: impresa.importoRichiesto || null,
    importoProvvigione: impresa.importoProvvigione || impresa.importoProvvigione === 0 ? impresa.importoProvvigione : null,
    istituto: impresa.istituto || null,
    numeroPraticaIstituto: impresa.numeroPraticaIstituto || "",
    importoErogato: impresa.importoErogato || impresa.importoErogato === 0 ? impresa.importoErogato : null,
    dataErogazione: impresa.dataErogazione ? moment.unix(impresa.dataErogazione) : null,
    stato: impresa.sato || 'aperta',
    scopoFinanziamento : impresa.scopoFinanziamento || null,
    durataMassima: impresa.durataMassima || null,
    garanziaSoggettiTerzi: impresa.garanziaSoggettiTerzi || false,
    praticheInSofferenza: impresa.praticheInSofferenza || false,
    pregiudizievoli: impresa.pregiudizievoli || false,
    pregiudizievoliDescription: impresa.pregiudizievoliDescription || "",
    esclusivitaContrattoKiron: impresa.esclusivitaContrattoKiron || false,
  };
};



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/ImpresaForm/Base/initialValues.js